<template>
  <div class="OrderList">
    <navigator title="订单中心"></navigator>
    <van-cell v-for="(item, index) in list" :key="index" :title="item.serviceName" is-link :to="'/personal/orderList?serviceFlag='+item.serviceFlag"/>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  data(){
    return{
      list: [],
      loading: false,
      finished: false,
    }
  },
  methods:{
    ...mapMutations(['change_parkServiceList']),
    getService() {  // 获取八大服务
      this.$http.post(`${this.URL_PREFIX}/app/get/park/service/list`, {
        parkId: this.currentParkId,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.list = res.resData.pageList;
          let arr = [];
          this.list.forEach((val) => {
            arr.push({
              serviceFlag: val.serviceFlag,
              serviceName: val.serviceName,
              serviceId: val.serviceId,
              children: val.childrenList
            })
          });
          this.change_parkServiceList(arr);
        }
      });
    },
  },
  created() {
    this.list = [];
    if(this.parkServiceList.length>0){
      this.parkServiceList.forEach((v)=>{
        this.list.push({
          serviceFlag: v.serviceFlag,
          serviceId: v.serviceId,
          serviceName: v.serviceName,
        });
      });
    }else{
      this.getService();
    }
    this.list.push({
      serviceFlag: 9,
      serviceId: 0,
      serviceName: '天安商城',
    });
  },
  computed: {
    ...mapGetters(['currentParkId','token','parkServiceList']),
  },
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/personal/Property.vue